import { ServiceLevel } from '@rygen/rygen-ui/model';

import { BaseHttpController } from './BaseHttpController';

export class ServiceLevelController extends BaseHttpController {
  static readonly ENDPOINT: string = 'service-level';

  constructor() {
    super(ServiceLevelController.ENDPOINT);
  }

  async findAll(): Promise<ServiceLevel[]> {
    const response = await this.http.get<ServiceLevel[]>('');
    return response.data.map((val) => new ServiceLevel(val));
  }
}
